export function composeBusinessPrompt(input) {
    return input.escalationPrompt?.trim()
        ? input.systemPrompt +
            "\n\n[Условия передачи менеджеру]\n" +
            input.escalationPrompt
        : input.systemPrompt;
}
export function emptyFunnelPromptFields() {
    return {
        promptMode: "MANUAL",
        promptForm: null,
        generatedPrompt: null,
        generationSnapshot: null,
        handoffConditions: null,
        escalationPrompt: null,
        promptVersion: 1,
    };
}
export function editablePromptFields(fields) {
    return {
        promptMode: fields.promptMode,
        promptForm: fields.promptForm,
        generatedPrompt: fields.generatedPrompt,
        generationSnapshot: fields.generationSnapshot,
        handoffConditions: fields.handoffConditions,
        escalationPrompt: fields.escalationPrompt,
    };
}
//# sourceMappingURL=prompt-builder.js.map